if (!customElements.get('fp-garment-video')) {
  customElements.define('fp-garment-video', class extends HTMLElement {
    connectedCallback() {
      this.video = this.querySelector('video');
      if (!this.video) return;
      this.video.muted = true;
      this.observer = new IntersectionObserver((entries) => {
        if (!entries[0].isIntersecting) this.video.pause();
      });
      this.observer.observe(this);
      this.onVisibility = () => { if (document.hidden) this.video.pause(); };
      document.addEventListener('visibilitychange', this.onVisibility);
    }
    disconnectedCallback() {
      this.video?.pause();
      this.observer?.disconnect();
      document.removeEventListener('visibilitychange', this.onVisibility);
    }
  });
}
